import { render, staticRenderFns } from "./fankui.vue?vue&type=template&id=2f233040&scoped=true&"
import script from "./fankui.vue?vue&type=script&lang=ts&"
export * from "./fankui.vue?vue&type=script&lang=ts&"
import style0 from "./fankui.vue?vue&type=style&index=0&id=2f233040&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f233040",
  null
  
)

export default component.exports